import React from "react";
import { motion } from "framer-motion";
import MenuCard from "./MenuCard";
import { menuItems } from "../data/menu";

export const MenuSection = () => {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Section header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center gap-2 rounded-full bg-[#FFFDF9] border border-[#3E2723]/10 px-4 py-2 text-xs font-bold tracking-widest uppercase text-[#3E2723]/80 shadow-sm mb-5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#D38C41]" /> Carta
              Premium
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-display font-black tracking-tight text-[#3E2723] leading-[0.95]"
              style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
              data-testid="menu-heading"
            >
              Elige tu <span className="italic text-[#D38C41]">obsesión</span>.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mt-4 max-w-xl text-[#5D4037] text-base md:text-lg font-body"
            >
              Seis combinaciones diseñadas para enamorarte desde el primer
              mordisco. Pide directo por WhatsApp y lo preparamos al instante.
            </motion.p>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="hidden md:flex items-center gap-3 self-end"
          >
            <div className="w-16 h-16 rounded-full bg-[#3E2723] text-[#FFF0F3] grid place-items-center font-display font-black text-xl">
              06
            </div>
            <div>
              <div className="font-display font-bold text-[#3E2723]">
                Waffles únicos
              </div>
              <div className="text-xs text-[#5D4037] uppercase tracking-wider">
                Dulces & salados
              </div>
            </div>
          </motion.div>
        </div>

        {/* Cards grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {menuItems.map((item, i) => (
            <MenuCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
